import { startingAwningPrice } from '../prerenderData';

// Displayed "From $X" starting price for the awning range.
//
// Derived at BUILD TIME from the lowest active awning price (see
// scripts/generate-prerender-data.mjs), rounded UP to the nearest $10. It MUST
// stay at or above the true cheapest awning - never advertise a "from" price
// below what a customer can actually be charged. Do not hardcode a lower value.
export const AWNING_FROM_PRICE = startingAwningPrice || 550;
export const AWNING_FROM_LABEL = `From $${AWNING_FROM_PRICE}`;
